/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreditCardAuthSubmittedRequest
 */
export interface CreditCardAuthSubmittedRequest {
    /**
     * The Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof CreditCardAuthSubmittedRequest
     */
    bookingId: string;
    /**
     * True to mark submitted; false to clear the submitted state.
     * @type {boolean}
     * @memberof CreditCardAuthSubmittedRequest
     */
    submitted?: boolean;
    /**
     * The client-observed ISO-8601 submission timestamp. Required when submitted is false.
     * @type {string}
     * @memberof CreditCardAuthSubmittedRequest
     */
    expectedSubmittedAt?: string | null;
}

/**
 * Check if a given object implements the CreditCardAuthSubmittedRequest interface.
 */
export function instanceOfCreditCardAuthSubmittedRequest(value: object): value is CreditCardAuthSubmittedRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function CreditCardAuthSubmittedRequestFromJSON(json: any): CreditCardAuthSubmittedRequest {
    return CreditCardAuthSubmittedRequestFromJSONTyped(json, false);
}

export function CreditCardAuthSubmittedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditCardAuthSubmittedRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'submitted': json['submitted'] == null ? undefined : json['submitted'],
        'expectedSubmittedAt': json['expected_submitted_at'] == null ? undefined : json['expected_submitted_at'],
    };
}

export function CreditCardAuthSubmittedRequestToJSON(json: any): CreditCardAuthSubmittedRequest {
    return CreditCardAuthSubmittedRequestToJSONTyped(json, false);
}

export function CreditCardAuthSubmittedRequestToJSONTyped(value?: CreditCardAuthSubmittedRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'submitted': value['submitted'],
        'expected_submitted_at': value['expectedSubmittedAt'],
    };
}
